const Skills = () => {
  const skills = [
    {
      title: "Frontend",
      languages: [
        "React.js",
        "React Native",
        "Next.js",
        "JavaScript",
        "TypeScript",
        "JSP",
        "HTML",
        "CSS",
        "Tailwind CSS",
        "GSAP"
      ],
    },
    {
      title: "Backend",
      languages: [
        "Java",
        "Node.js",
        "Express.js",
        "Python",
        "FastAPI"
      ],
    },
    {
      title: "Databases",
      languages: ["MongoDB", "SQLite", "Supabase"],
    },
    {
      title: "Testing & QA",
      languages: [
        "Postman",
        "Selenium (Basic)",
        "Appium (Basic)",
        "ADB Commands"
      ],
    },
    {
      title: "Tools & Tech",
      languages: [
        "Git",
        "GitHub",
        "Jira (Agile)",
        "VS Code",
        "IntelliJ IDEA",
        "MS Excel",
        "MS Word",
      ],
    },
    {
      title: "API Expertise",
      languages: [
        "REST API Integration"
      ],
    },
  ];

  return (
    <>
      <div className="px-5 max-w-[1560px] mx-auto mt-20 py-10">
        
        {/* Top Title */}
        <div data-aos="fade-left" className="mb-10">
          <div className="text-white w-2/3 font-medium text-[32px] flex items-center gap-2">
            <span className="text-[#C778DD]">⚙️</span> Skills
            <div className="line w-1/3 h-px bg-[#C778DD]"></div>
          </div>
        </div>

        {/* Content */}
        <div className="flex flex-wrap gap-10 justify-between items-center text-white">
          
          {/* Image left side (optional) */}
          <div data-aos="fade-right" className="mx-auto">
            <img
              className="w-full mx-auto"
              src={require("./imgs/shapes.png")}
              alt="skills-decoration"
            />
          </div>

          {/* Skills Grid */}
          <div
            data-aos="fade-left"
            className="mx-auto flex justify-around md:justify-end flex-wrap w-10/12 md:w-1/2 gap-4"
          >
            {skills.map(({ title, languages }) => (
              <div key={title} className="w-[90%] sm:w-[45%] lg:w-[30%] border border-[#ABB2BF]">
                <div className="p-2 font-semibold">{title}</div>
                <div className="flex gap-2 border-t border-[#ABB2BF] flex-wrap p-2 text-[#ABB2BF]">
                  {languages.map((item, idx) => (
                    <span key={idx}>{item}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Skills;
